import React from 'react';
import { Route, createRoutesFromElements } from 'react-router-dom';
import { MainLayout } from '../components/layouts/MainLayout';

// Lazy-load the route pages so the heavy ArticlePage (react-markdown + marked)
// and the other screens split out of the initial JS bundle. MainLayout stays
// eager so the header/footer shell renders immediately; the Suspense boundary
// lives around the <Outlet> in MainLayout.
const LandingPage = React.lazy(() =>
  import('../pages/LandingPage').then((m) => ({ default: m.LandingPage }))
);
const ArticlePage = React.lazy(() =>
  import('../pages/ArticlePage').then((m) => ({ default: m.ArticlePage }))
);
const Contact = React.lazy(() =>
  import('../pages/Contact').then((m) => ({ default: m.Contact }))
);
const AdminOnly = React.lazy(() =>
  import('../pages/AdminOnly').then((m) => ({ default: m.AdminOnly }))
);
const NotFound = React.lazy(() =>
  import('../pages/NotFound').then((m) => ({ default: m.NotFound }))
);

export const routes = createRoutesFromElements(
  <Route path="/" element={<MainLayout />}>
    <Route index element={<LandingPage />} />
    <Route path="articles/:slug" element={<ArticlePage />} />
    <Route path="contact" element={<Contact />} />

    {/* Admin-only index: lists the community-admin articles (pulled live from
        Supabase). Unlisted/soft-hidden — no public surface links here; reach it
        from the main app's admin dashboard. The articles themselves live at
        /articles/:slug like everything else. */}
    <Route path="admin-only" element={<AdminOnly />} />

    <Route path="*" element={<NotFound />} />
  </Route>
);
